module.exports = __webpack_public_path__ + "static/media/account-nav.4c5c63bb.svg";